(function () {
  "use strict";

  // TV compare popup: the one script for every page that offers it - the
  // homepage, the TVs collection and Google TV product pages (replaces
  // tv-compare-pdp.js). The popup markup, groups, prices and images come from
  // sections/tv-compare.liquid in the "TV compare" section group; this file
  // adds each page's Compare button, handles the popup and builds the spec
  // tables from getDetails() below - the single copy of the TV specs.
  //
  // Any element with data-tv-compare-open opens the popup.
  if (window.tvCompare) return;

  const OPEN_SELECTOR = "[data-tv-compare-open], .compare-btn";

  let popup = null;

  window.tvCompare = { open, close };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }

  document.addEventListener("click", (e) => {
    const trigger = e.target.closest(OPEN_SELECTOR);
    if (!trigger || !popup) return;

    e.preventDefault();
    open();
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && popup && popup.classList.contains("active"))
      close();
  });

  // Theme editor: the section re-renders in place, so swap in the new popup.
  document.addEventListener("shopify:section:load", (e) => {
    if (!e.target.querySelector("[data-tv-compare]")) return;

    if (popup) popup.remove();
    popup = null;
    init();
  });
  // By section id: by now the popup has moved out of its section.
  document.addEventListener("shopify:section:unload", (e) => {
    if (!popup || !e.detail || e.detail.sectionId !== popup.dataset.sectionId)
      return;

    close();
    popup.remove();
    popup = null;
  });

  function init() {
    const found = document.querySelector("[data-tv-compare]");
    if (!found || found === popup) return;

    popup = found;
    // Out of #PageContainer: its transform would pin position: fixed to it.
    document.body.prepend(popup);

    addPageButton();
    bindPopup();
    addDetails();
  }

  function open() {
    // Below the header as it sits now (it may have scrolled partly away).
    const header = document.getElementById("shopify-section-header");
    const top = header
      ? Math.max(0, Math.round(header.getBoundingClientRect().bottom))
      : 0;
    popup.style.setProperty("top", `${top}px`, "important");

    popup.classList.add("active");
    document.body.style.overflow = "hidden";
  }

  function close() {
    if (!popup) return;

    popup.classList.remove("active");
    popup
      .querySelectorAll(".select.open")
      .forEach((select) => select.classList.remove("open"));
    document.body.style.overflow = "";
  }

  // The homepage's button is in hp-tv-showcase; the collection and product
  // pages get one added here, where their old scripts put it.
  function addPageButton() {
    const page = popup.getAttribute("data-page");

    if (page === "collection") {
      const title = document.querySelector(
        "#MainContent .shopify-section:first-child .collection-title",
      );
      if (title && !title.querySelector(".tv_compare_btn"))
        title.append(
          pageButton(["tv_compare_btn"], popup.dataset.collectionButton),
        );
    } else if (page === "product") {
      const spacer = document.querySelector(".nav2-content .spacer");
      if (spacer && !document.querySelector(".pdp-compare-btn"))
        spacer.after(
          pageButton(
            ["btn", "spec-button", "pdp-compare-btn"],
            popup.dataset.productButton,
          ),
        );
    }
  }

  function pageButton(classes, label) {
    const button = document.createElement("button");
    button.type = "button";
    button.classList.add(...classes);
    button.setAttribute("data-tv-compare-open", "");
    button.textContent = label || "Compare";

    return button;
  }

  function bindPopup() {
    const closeButton = popup.querySelector(".tv_compare_popup_close_btn");
    closeButton.addEventListener("click", close);
    closeButton.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        close();
      }
    });

    popup.addEventListener("click", (e) => {
      const option = e.target.closest(".section_select .option");
      if (option) return selectGroup(option);

      const trigger = e.target.closest(".section_select .trigger");
      if (trigger) return toggleSelect(trigger.closest(".select"));

      const size = e.target.closest(".section_prodInfo .options button");
      if (size) return selectSize(size);

      // A click anywhere else closes an open group dropdown.
      popup
        .querySelectorAll(".select.open")
        .forEach((select) => select.classList.remove("open"));
    });
  }

  function toggleSelect(select) {
    popup.querySelectorAll(".select.open").forEach((other) => {
      if (other !== select) other.classList.remove("open");
    });
    select.classList.toggle("open");
  }

  // Group dropdown: show that group's sizes in the column and pick its first.
  function selectGroup(option) {
    const select = option.closest(".select");
    select.classList.remove("open");
    select
      .querySelectorAll(".option.selected")
      .forEach((el) => el.classList.remove("selected"));
    option.classList.add("selected");
    select.querySelector(".trigger span").textContent = option.textContent;

    const blockId = option.getAttribute("data-block_id");
    const index = option.closest(".section_select").getAttribute("data-index");
    const sizes = popup.querySelectorAll(
      `.section_prodInfo[data-index='${index}'] .options button`,
    );

    let first = null;
    sizes.forEach((button) => {
      const inGroup = button.getAttribute("data-block_id") === blockId;
      button.classList.toggle("hide", !inGroup);
      if (inGroup && !first) first = button;
    });

    if (first) selectSize(first);
  }

  // Size button: swap the column's image, price and CTA, then the specs.
  function selectSize(button) {
    button.parentElement
      .querySelectorAll("button.selected")
      .forEach((el) => el.classList.remove("selected"));
    button.classList.add("selected");

    const index = button.closest(".section_prodInfo").getAttribute("data-index");
    const info = popup.querySelector(`.section_prodInfo[data-index='${index}']`);
    const image = popup.querySelector(
      `.section_prodImg[data-index='${index}'] img`,
    );

    if (image) image.src = button.getAttribute("data-image");
    setText(info.querySelector(".price-wrapper"), button.dataset.price);
    setText(
      info.querySelector(".product-price__price.product-compare"),
      button.dataset.compare_at_price,
    );

    const cta = info.querySelector(".cta_wrapper a");
    if (cta) {
      cta.href = `/products/${button.getAttribute("data-handle")}`;
      cta.textContent = button.dataset.cta_text;
    }

    addDetails();
  }

  function setText(el, text) {
    if (el) el.textContent = text;
  }

  function currentHandles() {
    return Array.from(
      popup.querySelectorAll(".section_prodInfo button.selected:not(.hide)"),
      (button) => button.getAttribute("data-handle"),
    );
  }

  function addDetails() {
    const details = getDetails();
    const headers = getDetailHeaders();
    const handles = currentHandles();
    // A product added to a group before its spec entry shows blank specs
    // instead of breaking the table.
    const specs = handles.map(
      (handle) => details[handle] || details["default-settings"],
    );

    const compareList = popup.querySelector(".compare_list");
    const wrapper =
      compareList.querySelector(".details_wrapper") ||
      document.createElement("div");
    wrapper.classList.add("details_wrapper");
    wrapper.style.gridColumn = "1 / -1";

    // Rows per table; the summary is image rows, the rest header/value pairs.
    const order = [
      { title: "Summary", length: 12 },
      { title: "Display", length: 14 },
      { title: "Audio", length: 5 },
      { title: "Features", length: 8 },
      { title: "Size & Weight", length: 5 },
      { title: "Connectivity", length: 11 },
    ];

    // Temporary: HLG shows as DLG for the 2026 models.
    const models2026 = [
      "q43u-2026",
      "q55u-2026",
      "q65u-2026",
      "q75u-2026",
      "q85u-2026",
      "q43qe-2026",
      "q55qe-2026",
      "q65qe-2026",
      "q75qe-2026",
      "u55-2026",
      "u65-2026",
      "u75-2026",
    ];

    const sizeLabel = (column) => {
      const button = popup.querySelector(
        `.section_prodInfo[data-index="${column + 1}"] .options button[data-handle="${handles[column]}"]`,
      );

      return button ? button.innerHTML : "";
    };

    let start = 0;
    wrapper.innerHTML = order
      .map(({ title, length }, tableIndex) => {
        const isSummary = tableIndex === 0;
        const offset = start;
        start += length;

        const rows = [...Array(length).keys()]
          .map((x) => {
            const row = x + offset;

            // Temporary: Bluetooth Audio is hidden.
            if (row === 38) return "";

            if (isSummary) {
              return `<tr>${[0, 1, 2]
                .map((y) => {
                  const url = specs[y] && specs[y][row];
                  return url
                    ? `<td><img src="${url}" alt="" width="" height="" /></td>`
                    : "<td></td>";
                })
                .join("")}</tr>`;
            }

            const head = [0, 1, 2]
              .map((y) =>
                models2026.includes(handles[y]) && row === 22
                  ? "<th>DLG</th>"
                  : `<th>${headers[row - 12]}</th>`,
              )
              .join("");
            const values = [0, 1, 2]
              .map((y) => `<td>${(specs[y] && specs[y][row]) || ""}</td>`)
              .join("");

            return `<tr>${head}</tr><tr>${values}</tr>`;
          })
          .join("");

        const sizes = isSummary
          ? `<tr>${[0, 1, 2]
              .map((y) => `<td class="tv-size">${sizeLabel(y)}</td>`)
              .join("")}</tr>`
          : "";

        return `
          <p class="details-title">${title}</p>
          <table data-section="${title.toLowerCase()}">${sizes}${rows}</table>
        `;
      })
      .join("");

    compareList.append(wrapper);
  }

  // ── TV specs ────────────────────────────────────────────────────────────
  // One array per product handle, in the order of the tables above: 12
  // summary icon URLs, then the values for getDetailHeaders(). Add an entry
  // here when a new TV joins a group in the "TV compare" section.

  function getDetails() {
    const icons = getIcons();

    const details = {
      "default-settings": [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ],

      // Q Series Ultra 2026
      "q43u-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+ Gaming"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "QLED+",
        "4K (3840x2160)",
        "94% DCI-P3",
        "N/A",
        "260 nits",
        "N/A",
        "N/A",
        "120Hz DLG *Feature must be enabled in settings. Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10+ Gaming",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "48W",
        "N/A",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "957.2 x 73.2 x 559.7 mm",
        "957.2 x 238.5 x 608.4 mm",
        "5.7 kg",
        "5.9 kg",
        "300 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "q55u-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+ Gaming"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "QLED+",
        "4K (3840x2160)",
        "94% DCI-P3",
        "N/A",
        "300 nits",
        "N/A",
        "N/A",
        "120Hz DLG *Feature must be enabled in settings. Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10+ Gaming",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "48W",
        "N/A",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1226 x 74 x 708.9 mm",
        "1226 x 308.7 x 776 mm",
        "9.1 kg",
        "9.2 kg",
        "300 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "q65u-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+ Gaming"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "QLED+",
        "4K (3840x2160)",
        "94% DCI-P3",
        "N/A",
        "320 nits",
        "N/A",
        "N/A",
        "120Hz DLG *Feature must be enabled in settings. Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10+ Gaming",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "60W",
        "N/A",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1445.6 x 83.2 x 834.3 mm",
        "1445.6 x 338 x 902.7 mm",
        "14 kg",
        "14.2 kg",
        "400 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "q75u-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+ Gaming"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "QLED+",
        "4K (3840x2160)",
        "94% DCI-P3",
        "N/A",
        "350 nits",
        "N/A",
        "N/A",
        "120Hz DLG *Feature must be enabled in settings. Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10+ Gaming",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "60W",
        "N/A",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1667.7 x 75 x 959.5 mm",
        "1667.7 x 398.7 x 1027.5 mm",
        "18.5 kg",
        "18.9 kg",
        "400 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "q85u-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+ Gaming"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "QLED+",
        "4K (3840x2160)",
        "94% DCI-P3",
        "N/A",
        "400 nits",
        "N/A",
        "N/A",
        "120Hz DLG *Feature must be enabled in settings. Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10+ Gaming",
        "N/A",
        "Yes",
        "Yes",
        "Yes",
        "60W",
        "N/A",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "1890 x 91.3 x 1081.1 mm",
        "1890 x 398.3 x 1176.7 mm",
        "28.8 kg",
        "29.5 kg",
        "400 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],

      // Q Ultra Series
      "prism-q55-ultra": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Dbx-TV"],
        icons["Eye-Care"],
        "QLED+",
        "4K (3840x2160)",
        "118% DCI-P3",
        "N/A",
        "N/A",
        "316 nits",
        "N/A",
        "120Hz (High-frame Scan Rate at 4k) or 120Hz VRR at FHD",
        "120 Smooth Motion",
        "HDR10+",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "40W",
        "N/A",
        "Yes",
        "Yes",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1225 x 80 x 721 mm",
        "1225 x 290 x 775 mm",
        "9.86 kg",
        "10.06 kg",
        "200 x 200",
        "1",
        "2",
        "N/A",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "q75u-q75-ultra-qled-google-tv": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Dbx-TV"],
        icons["Eye-Care"],
        icons["MEMC Real Motion"],
        "QLED+",
        "4K (3840x2160)",
        "91% DCI-P3",
        "N/A",
        "N/A",
        "447 nits",
        "N/A",
        "120Hz (High-frame Scan Rate at 4k) or 120Hz VRR at FHD",
        "120 Smooth Motion",
        "HDR10+",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "60W",
        "N/A",
        "Yes",
        "Yes",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1667 x 87 x 965 mm",
        "1667 x 320 x 1025 mm",
        "20.06 kg",
        "20.40 kg",
        "400 x 200",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "prism-q100-ultra-qled-google-tv": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Dbx-TV"],
        icons["Eye-Care"],
        icons["MEMC Real Motion"],
        "QLED",
        "4K (3840x2160)",
        "90% DCI-P3",
        "5000:1",
        "N/A",
        "600 nits",
        "N/A",
        "120Hz",
        "N/A",
        "HDR10+",
        "N/A",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W + 2 x 10W",
        "1 x 40W",
        "Yes",
        "N/A",
        "Yes",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "2240 x 90 x 1270 mm",
        "2240 x 425 x 1350 mm",
        "72 kg",
        "73.50 kg",
        "800 x 400",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],

      // Q QE Series 2026
      "q43qe-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons.HDR10,
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "",
        "VA",
        "4K (3840x2160)",
        "N/A",
        "N/A",
        "300 nits",
        "N/A",
        "N/A",
        "60Hz",
        "N/A",
        "HDR10",
        "N/A",
        "Yes",
        "Yes",
        "Yes",
        "48W",
        "N/A",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "957.4 x 80.6 x 556.2 mm",
        "957.4 x 229.4 x 608.5 mm",
        "6.4 kg",
        "6.5 kg",
        "300 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "q55qe-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons.HDR10,
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "VA",
        "4K (3840x2160)",
        "N/A",
        "N/A",
        "270 nits",
        "N/A",
        "N/A",
        "120Hz DLG *Feature must be enabled in settings. Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "48W",
        "N/A",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1226 x 74 x 708.9 mm",
        "1226 x 308.7 x 776 mm",
        "9.1 kg",
        "9.2 kg",
        "300 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "q65qe-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons.HDR10,
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "VA",
        "4K (3840x2160)",
        "N/A",
        "N/A",
        "320 nits",
        "N/A",
        "N/A",
        "120Hz DLG *Feature must be enabled in settings. Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "60W",
        "N/A",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1445.6 x 83.2 x 834.3 mm",
        "1445.6 x 338 x 902.7 mm",
        "14 kg",
        "14.2 kg",
        "400 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "q75qe-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons.HDR10,
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "VA",
        "4K (3840x2160)",
        "N/A",
        "N/A",
        "350 nits",
        "N/A",
        "N/A",
        "120Hz DLG *Feature must be enabled in settings. Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "60W",
        "N/A",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1667.7 x 75 x 955.5 mm",
        "1667.7 x 398.7 x 1027.5 mm",
        "18.5 kg",
        "18.9 kg",
        "400 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],

      // Q Series QE
      "q55qe-a-q55qe-google-tv": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons.HDR10,
        icons["Dbx-TV"],
        icons["Eye-Care"],
        "IPS",
        "4K (3840x2160)",
        "93% DCI-P3",
        "N/A",
        "N/A",
        "340 nits",
        "N/A",
        "60Hz",
        "120 Smooth Motion",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "40W",
        "N/A",
        "Yes",
        "Yes",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1225 x 80 x 726 mm",
        "1225 x 260 x 782 mm",
        "9.74 kg",
        "9.92 kg",
        "200 x 200",
        "1",
        "2",
        "N/A",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "q65qe-a-q65qe-google-tv": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons.HDR10,
        icons["Dbx-TV"],
        icons["Eye-Care"],
        "IPS",
        "4K (3840x2160)",
        "85% DCI-P3",
        "N/A",
        "N/A",
        "314 nits",
        "N/A",
        "60Hz",
        "120 Smooth Motion",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "60W",
        "N/A",
        "Yes",
        "Yes",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1447 x 80 x 840 mm",
        "1447 x 290 x 910 mm",
        "14.66 kg",
        "14.92 kg",
        "400 x 200",
        "1",
        "2",
        "N/A",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],

      // U Series 2026
      "u55-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+ Gaming"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "",
        "Quantum Dot Mini-LED",
        "4K (3840x2160)",
        "92% DCI-P3",
        "1,000,000:1",
        "N/A",
        "900 nits",
        "N/A",
        "120Hz DLG *120Hz Game Mode must be enabled in settings. Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10+ Gaming",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W",
        "1 x 40W",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "1225.8 x 77.3 x 713.3 mm",
        "1225.8 x 291.5 x 776.3 mm",
        "12.5 kg",
        "12.8 kg",
        "400 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "u65-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+ Gaming"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "",
        "Quantum Dot Mini-LED",
        "4K (3840x2160)",
        "102% DCI-P3",
        "1,000,000:1",
        "N/A",
        "800 nits",
        "N/A",
        "120Hz DLG *120Hz Game Mode must be enabled in settings. Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10+ Gaming",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W",
        "1 x 40W",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "1445.2 x 78 x 834.2 mm",
        "1445.2 x 336.7 x 901.9 mm",
        "18 kg",
        "18.5 kg",
        "400 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "u75-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+ Gaming"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "",
        "Quantum Dot Mini-LED",
        "4K (3840x2160)",
        "102% DCI-P3",
        "1,000,000:1",
        "N/A",
        "800 nits",
        "N/A",
        "120Hz DLG *120Hz Game Mode must be enabled in settings. Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10+ Gaming",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W",
        "1 x 40W",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "1667.3 x 78.3 x 959.3 mm",
        "1667.3 x 374.6 x 1026.5 mm",
        "25.5 kg",
        "26.2 kg",
        "400 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],

      // U Series
      "prism-u55-qd-mini-led": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["144Hz"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        "",
        "",
        "",
        "Quantum Dot Mini-LED",
        "4K (3840x2160)",
        "93% DCI-P3",
        "1,000,000:1",
        "N/A",
        "550 nits",
        "N/A",
        "144Hz VRR (Variable Refresh Rate) *Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W",
        "1 x 40W",
        "Yes",
        "N/A",
        "Yes",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "1233 x 88 x 721 mm",
        "1233 x 254 x 757 mm",
        "15.1 kg",
        "18.7 kg",
        "300 x 200",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "u65-qled-mini-led-google": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["144Hz"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        "",
        "",
        "",
        "Quantum Dot Mini-LED",
        "4K (3840x2160)",
        "93% DCI-P3",
        "1,000,000:1",
        "N/A",
        "600 nits",
        "N/A",
        "144Hz VRR (Variable Refresh Rate)",
        "N/A",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W",
        "1 x 40W",
        "Yes",
        "N/A",
        "Yes",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "1453 x 290 x 881 mm",
        "1453 x 88 x 845 mm",
        "22.5 kg",
        "27.8 kg",
        "400 x 200",
        "1",
        "2",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "u75-qled-mini-led-google": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["144Hz"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        "",
        "",
        "",
        "Quantum Dot Mini-LED",
        "4K (3840x2160)",
        "93% DCI-P3",
        "1,000,000:1",
        "N/A",
        "600 nits",
        "N/A",
        "144Hz VRR (Variable Refresh Rate) *Subject to gaming console and PC graphics card compatibility",
        "N/A",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W",
        "1 x 40W",
        "Yes",
        "N/A",
        "Yes",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "1675 x 330 x 1008 mm",
        "1675 x 88 x 973 mm",
        "32.9 kg",
        "40.2 kg",
        "400 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "prism-u86-qd-mini-led": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["144Hz"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        "",
        "",
        "",
        "Quantum Dot Mini-LED",
        "4K (3840x2160)",
        "93% DCI-P3",
        "1,000,000:1",
        "N/A",
        "600 nits",
        "N/A",
        "144Hz VRR (Variable Refresh Rate) *Subject to gaming console and PC graphics card compatibility",
        "N/A",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W",
        "1 x 40W",
        "Yes",
        "N/A",
        "Yes",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "1925 x 97 x 1109 mm",
        "1925x 380 x 1144 mm",
        "43.8 kg",
        "55 kg",
        "600 x 400",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],

      // U Ultra-Series
      "prism-u55-ultra-qd-mini-led-4k-ai-google-tv": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["144Hz"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        "",
        "",
        "",
        "Quantum Dot Mini-LED",
        "4K (3840x2160)",
        "110% DCI-P3",
        "1,000,000:1",
        "N/A",
        "1750 nits",
        "720",
        "144Hz",
        "N/A",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W",
        "1 x 40W",
        "Yes",
        "N/A",
        "Yes",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "N/A",
        "1233 x 86.8 x 771.5 mm",
        "1233 x 230 x 721.6 mm",
        "14.9 kg",
        "15.2 kg",
        "300 x 200",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "prism-u65-ultra-qd-mini-led-4k-ai-google-tv": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["Omniview"],
        icons["144Hz"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        "",
        "",
        "Quantum Dot Mini-LED",
        "4K (3840x2160)",
        "107% DCI-P3",
        "1,000,000:1",
        "N/A",
        "2250 nits",
        "1152",
        "144Hz",
        "N/A",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W",
        "1 x 40W",
        "Yes",
        "N/A",
        "Yes",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "N/A",
        "1452.5 x 87.17 x 845.26 mm",
        "1452.5 x 324.92 x 904.14 mm",
        "22.2 kg",
        "22.6 kg",
        "400 x 200",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "prism-u75-ultra-qd-mini-led-4k-ai-google-tv": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["Omniview"],
        icons["144Hz"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        "",
        "",
        "Quantum Dot Mini-LED",
        "4K (3840x2160)",
        "114% DCI-P3",
        "1,000,000:1",
        "N/A",
        "2040 nits",
        "1440",
        "144Hz",
        "N/A",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W",
        "1 x 40W",
        "Yes",
        "N/A",
        "Yes",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "N/A",
        "1674.5 x 86.8 x 973.3 mm",
        "1674.5 x 325 x 1030.9 mm",
        "32.4 kg",
        "32.9 kg",
        "400 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "prism-u86-ultra-qd-mini-led-4k-ai-google-tv": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["Omniview"],
        icons["144Hz"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        "",
        "",
        "Quantum Dot Mini-LED",
        "4K (3840x2160)",
        "110% DCI-P3",
        "1,000,000:1",
        "N/A",
        "2320 nits",
        "1800",
        "144Hz",
        "N/A",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W",
        "1 x 40W",
        "Yes",
        "N/A",
        "Yes",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "N/A",
        "1924.8 x 95.4 x 1109.4 mm",
        "1924.8 x 379.9 x 1178.4 mm",
        "43.0 kg",
        "43.8 kg",
        "600 x 400",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],

      // S Series
      "s32-google-tv": [
        icons["Google TV"],
        icons.HDR10,
        icons["Dolby Audio"],
        icons.DTS,
        icons["MEMC Real Motion"],
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "Direct LED (DLED)",
        "HD (1366 x 768)",
        "114% sRGB",
        "N/A",
        "N/A",
        "253 nits",
        "N/A",
        "N/A",
        "N/A",
        "HDR10",
        "N/A",
        "N/A",
        "Yes",
        "N/A",
        "2 x 20W",
        "N/A",
        "Yes",
        "N/A",
        "N/A",
        "N/A",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "718 x 70.2 x 426.8 mm",
        "718 x 177.6 x 466.6 mm",
        "3.48 kg",
        "3.52 kg",
        "200 x 200",
        "N/A",
        "N/A",
        "N/A",
        "2",
        "2",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "prism-s40-google-tv": [
        icons["Google TV"],
        icons.HDR10,
        icons["Dolby Audio"],
        icons.DTS,
        icons["MEMC Real Motion"],
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "Direct LED (DLED)",
        "FHD (1920 x1080)",
        "117% sRGB",
        "N/A",
        "N/A",
        "253 nits",
        "N/A",
        "N/A",
        "N/A",
        "HDR10",
        "N/A",
        "N/A",
        "Yes",
        "N/A",
        "2 x 20W",
        "N/A",
        "Yes",
        "N/A",
        "Yes",
        "N/A",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "892 x 74.2 x 510.6 mm",
        "892 x 211.8x 556.6 mm",
        "4.7 kg",
        "4.81 kg",
        "200 x 100",
        "N/A",
        "N/A",
        "N/A",
        "2",
        "2",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "prism-s43-google-tv": [
        icons["Google TV"],
        icons.HDR10,
        icons["Dolby Audio"],
        icons.DTS,
        icons["MEMC Real Motion"],
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "Direct LED (DLED)",
        "FHD (1920 x1080)",
        "106% sRGB",
        "N/A",
        "N/A",
        "228 nits",
        "N/A",
        "N/A",
        "N/A",
        "HDR10",
        "N/A",
        "N/A",
        "Yes",
        "N/A",
        "2 x 20W",
        "N/A",
        "Yes",
        "N/A",
        "Yes",
        "N/A",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "954.5 x 75.4 x 558.6 mm",
        "954.5 x 211.8 x 602.8 mm",
        "5.45 kg",
        "5.5 kg",
        "200 x 200",
        "N/A",
        "N/A",
        "N/A",
        "2",
        "2",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],

      // AL Series
      "prism-55al-google-tv": [
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision IQ"],
        icons["Dolby Atmos"],
        icons["Filmmaker Mode"],
        icons["HDR10+"],
        icons["MEMC Real Motion"],
        icons.DTS,
        "",
        "",
        "",
        "OLED",
        "4K (3840x2160)",
        "98.5% DCI-P3",
        "N/A",
        "N/A",
        "800 nits",
        "N/A",
        "120Hz ",
        "N/A",
        "HDR10+",
        "N/A",
        "Yes",
        "Yes",
        "Yes",
        "2 x 12W + 2 x 5W",
        "20W",
        "Yes",
        "N/A",
        "Yes",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1225 x 50 x 710 mm",
        "1225 x 260 x 756 mm",
        "18.7 kg",
        "20.5 kg",
        "300 x 200",
        "1",
        "N/A",
        "2",
        "1",
        "N/A",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "prism-65al-google-tv": [
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision IQ"],
        icons["Dolby Atmos"],
        icons["Filmmaker Mode"],
        icons["HDR10+"],
        icons["MEMC Real Motion"],
        icons.DTS,
        "",
        "",
        "",
        "OLED",
        "4K (3840x2160)",
        "98.5% DCI-P3",
        "N/A",
        "N/A",
        "700 nits",
        "N/A",
        "120Hz ",
        "N/A",
        "HDR10+",
        "N/A",
        "Yes",
        "Yes",
        "Yes",
        "2 x 12W + 2 x 5W",
        "20W",
        "Yes",
        "N/A",
        "Yes",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1450 x 50 x 835 mm",
        "1450 x 260 x 880 mm",
        "23 kg",
        "24.7 kg",
        "300 x 200",
        "1",
        "N/A",
        "2",
        "1",
        "N/A",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
    };

    return details;
  }

  function getDetailHeaders() {
    const headers = [
      "Panel Technology",
      "Resolution",
      "Colour Gamut",
      "Contrast Ratio",
      "Typical Brightness",
      "Peak Brightness",
      "Zones",
      "Refresh Rate",
      "Motion Rate",
      "HDR",
      "HLG",
      "Filmmaker Mode",
      "MEMC Motion Smoothing",
      "Dolby Vision",

      "Sound Output Speakers (Peak Power)",
      "Sound Output Subwoofer (Peak Power)",
      "Dolby Atmos",
      "Dbx-TV",
      "DTS TruSurround",

      "AI Processor",
      "App store",
      "Compatible Apps",
      "Casting",
      "Google Assistant Voice Control",
      "Digital TV Tuner",
      "Eye Care",
      "Bluetooth Audio",

      "Dimension w/o stand (LxWxH)",
      "Dimension w/ stand (LxWxH)",
      "Net Weight w/o stand",
      "Net Weight w/ stand",
      "VESA Mounting",

      "HDMI 2.1 with Enhanced Audio Return Channel (eARC)",
      "HDMI 2.1",
      "HDMI 2.0",
      "USB 2.0",
      "USB 3.0",
      "AV Input",
      "RF Input",
      "Ethernet Lan",
      "SPDIF Out",
      "Wi-Fi",
      "Bluetooth",
    ];

    return headers;
  }

  function getIcons() {
    const icons = {
      "AI Processor":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/AI_Processor_Icon_7ea5b1e8-5ebe-48bb-bf31-59b53768e6b7.png?v=1760087967",
      "Google TV":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Google_TV_Icon_c69d8cb0-7904-4bf2-926c-b4ee0c32df08.png?v=1760087967",
      "4K Ultra HD":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/4K_Ultra_HD_Icon_42e55df4-7723-4522-8708-492f4e41efba.png?v=1760087966",
      "120Hz":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/120Hz_Icon_39074d28-02c0-433b-8d4f-6b6490c3f15d.png?v=1760087967",
      "Dolby Vision":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Dolby_Vision_Icon_bfb82158-81d3-48e8-a7c1-f0fe6f5a97fd.png?v=1760087966",
      "Dolby Atmos":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Dolby_Atmos_Icon_eec9ad2a-55ca-4dd7-89f9-13736924ccca.png?v=1760087967",
      "HDR10+":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/HDR10_Icon_ae9d0293-df68-4937-b7c3-039d6ee82341.png?v=1760087966",
      "Filmmaker Mode":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Filmmaker_Mode_Icon_975463d3-8102-4d98-859c-16b03de2c335.png?v=1760087967",
      "MEMC Real Motion":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/MEMC_Real_Motion_Icon_2d35d8cb-8a7c-4e9c-a085-465400b8e9ba.png?v=1760087967",
      "Dbx-TV":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Dbx-TV_Icon_ecd35df2-6d41-4de3-83b6-b3baf28a8d3a.png?v=1760087967",
      "Eye-Care":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Eye-Care_Icon_888b38e2-61e3-4837-a5c0-1442ab976bd8.png?v=1760087966",
      HDR10:
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/HDR10_Icon_a7449031-6c69-46c6-a018-68711b50d8d2.png?v=1760087965",
      "144Hz":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/144Hz_Icon_ba9710fd-ba5f-4e43-8a5e-0df9eb4bd970.png?v=1760087966",
      "Dolby Vision IQ":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Dolby_Vision_IQ_Icon_7319f882-8c1a-4a35-abb3-cdc2553ec92f.png?v=1760087966",
      "Dolby Audio":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Dolby_Audio_icon_48f32d34-e8e0-452b-987d-7557ab4e0cea.png?v=1760087966",
      DTS: "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/DTS_Icon_563f56fb-90ac-49a5-9dbb-42a6a10a89c2.png?v=1760087966",
      // OmniView:
      //   "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/OmniView_Icon_e260087b-be29-41b1-b453-95594f6c478d.png?v=1761551263",
      "Apple Airplay":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Apple_Airplay.jpg?v=1765515832",
      "120Hz New":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/120hz_icon_b793bf94-1475-4bd3-a3db-2b5d7f78f067.png?v=1766572727",
      "HDR10+ Gaming":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/HDR10_Gaming_black.png?v=1773979307",
      Omniview: "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Omniview.png?v=1775614539",
    };

    return icons;
  }
})();
